import { Icon } from '../icons';
import { formatDate, labelKind, truncate } from '../utils';
import { StatusDot } from './Status';

export function MemoryList({ items, onSelect, limit, title = 'Recent memories', action, empty = 'No memories match this view.', selectable = false, selected = new Set(), onToggle }) {
  const visible = Number.isFinite(limit) ? items.slice(0, limit) : items;
  return (
    <section className={`memory-list ${selectable ? 'is-selectable' : ''}`}>
      <div className="section-heading memory-list__heading">
        <div><h2>{title}</h2><p>{items.length} items</p></div>
        {action ? <button className="text-action" onClick={action.onClick}>{action.label} <span>→</span></button> : null}
      </div>
      <div className="memory-list__header" aria-hidden="true">{selectable ? <span/> : null}<span>Title</span><span>Project</span><span>Date</span><span>Status</span><span>Scope</span></div>
      <div className="memory-list__rows">
        {visible.length ? visible.map((item) => (
          <div key={`${item.kind}-${item.id}`} className={`memory-row-wrap ${selected.has(`${item.kind}:${item.id}`) ? 'is-selected' : ''}`}>
            {selectable ? <label className="memory-select" aria-label={`Select ${item.title}`}><input type="checkbox" checked={selected.has(`${item.kind}:${item.id}`)} onChange={()=>onToggle(item)}/><span/></label> : null}
            <button className="memory-row" onClick={() => onSelect(item)}>
              <span className="memory-row__title"><Icon name={item.kind === 'skill' ? 'skills' : item.kind === 'group' ? 'knowledge' : 'document'} size={16} /><span><strong>{item.title}</strong><small>{labelKind(item.kind)}</small></span></span>
              <span className="memory-row__project">{item.project || 'Codex memory'}</span>
              <span className="memory-row__date">{formatDate(item.updatedAt, { year: false })}</span>
              <StatusDot status={item.status} />
              <span className="memory-row__scope">{truncate(item.description || item.scope || item.context || item.description, 100)}</span>
              <Icon name="chevron" size={15} className="memory-row__chevron" />
            </button>
          </div>
        )) : <div className="empty-state"><Icon name="search" size={24}/><p>{empty}</p></div>}
      </div>
    </section>
  );
}
